import { render, staticRenderFns } from "./ModificadoresForm.vue?vue&type=template&id=34895712&scoped=true"
import script from "./ModificadoresForm.vue?vue&type=script&lang=js"
export * from "./ModificadoresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34895712",
  null
  
)

export default component.exports